export const getMessagesAmount = (ticket) =>
	ticket[ticket.type].message?.length + ticket._stored_documents?.length;
